import React from "react";
import cx from "classnames";

export const Button = ({ label, className, ...rest }) => {
  return (
    <button
      className={cx(
        "text-12-22 uppercase font-mulish py-8 px-20 rounded-sm tracking-16 font-semibold focus:outline-none",
        className
      )}
      {...rest}>
      {label}
    </button>
  );
};

export const ButtonLarge = ({ label, className, ...rest }) => {
  return (
    <button
      className={cx(
        "text-14-22 uppercase font-mulish py-14 px-20 rounded-sm tracking-16 font-semibold focus:outline-none",
        className
      )}
      {...rest}>
      {label}
    </button>
  );
};

export const ButtonFullWidth = ({ label, className, smallText, ...rest }) => {
  return (
    <button
      className={cx(
        "uppercase font-mulish px-20 w-full tracking-16 font-semibold focus:outline-none",
        { "text-14-22 py-14": !smallText },
        { "text-12-22 py-7": smallText },
        className
      )}
      {...rest}>
      {label}
    </button>
  );
};
